import styled from 'styled-components'
import { BoldText } from '../../../theme/typography'

export const Container = styled.div`
  display: flex;
  gap: 0.6rem;
  align-items: center;
  justify-content: space-between;
  min-width: 255px;
  max-height: 100%;
  outline: none;
  border: none;
  background: #fff;
  border-radius: 10px;
  padding: 12px;

  font-family: Inter;
  font-style: normal;
  font-weight: normal;
  font-size: 16px;
  line-height: 15px;

  box-shadow: 4px 4px 18px -5px rgba(218, 221, 232, 0.8);

  &:focus::placeholder {
    color: transparent;
  }

  color: #526482;
  position: relative;
  margin-right: auto;
      @media(max-width:768px){
      min-width:100%;
    }
`

export const DropDown = styled.select`
  display: block;
  font-size: 16px;
  font-family: sans-serif;
  font-weight: 700;
  color: #444;
  line-height: 1.3;
  padding: 0.6em 2em 0.5em 0.5em;
  margin-right: -2rem;
  /* max-width: 100%; */
  box-sizing: border-box;
  border: none;
  border-radius: 0.5em;
  -moz-appearance: none;
  -webkit-appearance: none;
  appearance: none;
  background-color: transparent;

  /* linear-gradient(to bottom, #ffffff 0%,#e5e5e5 100%); */
  background-repeat: no-repeat, repeat;

  background-position: right 0.7em top 50%, 0 0;

  background-size: 1em auto, 100%;
  appearance: none;
  z-index: 1;
  @media (max-width: 768px) {
  width:87%;
  }

`
export const StyledBoldText = styled(BoldText)`
  width:17%;

`
